export const logger = function (...args: unknown[]) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, no-console
  console.log(...args);
};
